import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';

import translationsPL from './translations/pl.json';
import translationsEN from './translations/en.json';

const resources = {
  pl: {
    translation: translationsPL,
  },
  en: {
    translation: translationsEN,
  },
};
const fallbackLanguage = 'pl';
const availableLanguages = Object.keys(resources);

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    detection: {
      convertDetectedLanguage: (lng) => {
        const detectedLng = (lng || fallbackLanguage).split('-')[0];

        if (availableLanguages.includes(detectedLng)) {
          return detectedLng;
        }

        return fallbackLanguage;
      },
    },
    resources,
    fallbackLng: fallbackLanguage,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
